import React, { Component } from 'react';
import { Form, Button, Input, message } from 'antd';
const FormItem = Form.Item;
import styles from './login.less'
import loginBgImg from '@/assets/img/login_bg.png';

class Login extends Component {
  constructor(props){
    super(props);
  }
  form = React.createRef();

  login = () => {
    this.form.current.validateFields().then(values => {
      window.sessionStorage.setItem('token', Math.random());
      this.props.history.push('/home');
    }).catch(() => {
    })
  }

  render() {
    return (
      <div className={styles.loginContainer}>
        <div className={styles.main}>
          <div className={`left ${styles.imgDv}`}>
            <img src={loginBgImg} />
          </div>
          <div className={`left ${styles.loginDv}`}>
            <h1 style={{height:60, lineHeight:'60px', textAlign:'center'}}>XXX管理系统</h1>
            <Form ref={this.form}>
              <FormItem name="username" style={{marginTop: 50}} rules={[
                {required: true, message: '请输入登录名'}
              ]}>
                <Input type="text" size="large" placeholder="请输入登录名" />
              </FormItem>
              <FormItem name="password" style={{marginTop: 30}} rules={[
                  {required: true, message: '请输入密码'}
                ]}>
                <Input type="password" size="large" placeholder="请输入密码" />
              </FormItem>
              <FormItem style={{marginTop: 50}}>
                <Button type="primary" size="large" onClick={this.login} style={{width: '100%'}}>登录</Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;